module.exports = __webpack_public_path__ + "static/4-66719c3ee5f95192da84e553b9b894cd.jpg";